// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { ACTION, wrap } from './index';
import { Dispatch } from 'redux';
import {
  SchemaGetSearchTermQueryParams,
  SchemaLocationItem,
  SchemaPostSearchTermRequestBody,
} from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const getSearchResults = (params: SchemaGetSearchTermQueryParams & { signal: AbortSignal }) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      const { data, error } = await legacyApi.GET('/searchterm', { params: { query: params }, signal: params.signal });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.SEARCH_RESULT, payload: data });
      return data;
    } catch (err) {
      if (!String(err as any).includes('SEARCH_RESULTS_ABORT')) {
        console.error('error: ', err);
        throw err;
      }
    }
  }, 'GET_ERROR');

// TODO: APG-129 Body or query params, not both:
export const postImportResults = (payload: SchemaPostSearchTermRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      const { data, error } = await legacyApi.POST(
        '/searchterm',
        // @ts-expect-error has not needed query params
        {
          body: payload,
        },
      );

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.POST_IMPORT_DATA, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      throw err;
    }
  }, 'POST_ERROR');

export const highlightLocation = (payload: string) => ({
  type: constants.HIGHLIGHT_LOCATION,
  payload,
});

export const setFastbookData = (payload: any) => ({
  type: constants.SET_FASTBOOK_DATA,
  payload,
});

export const clearLocations = () => ({
  type: constants.CLEAR_LOCATIONS,
});

export const updateLocation = (payload: SchemaLocationItem): ACTION => ({
  type: constants.UPDATE_LOCATION,
  payload,
});

export const addLocation = (payload: SchemaLocationItem): ACTION => ({
  type: constants.ADD_LOCATION,
  payload,
});
